import style from "./style.module.scss";

const ButtonActions = props => {
  const { className, label = "Ações", options = [], disabled } = props;
  return (
    <div
      className={style.button_action}
      data-action-parent="true"
      data-disabled={disabled}
      onClick={__ev => {
        if (disabled) return false;
        const _action_parent = __ev.target.closest('*[data-action-parent="true"');
        _action_parent.setAttribute("data-close", "true");
        setTimeout(() => {
          _action_parent.removeAttribute("data-close");
        }, 10);
      }}
    >
      <div className={`${className} ${style.button}`}>
        {label} <span className={style.arrow}></span>
      </div>
      <div className={style.actions}>
        {options.map(__option => {
          const { label = "", onClick = () => {} } = __option;
          return (
            <div
              className={style.option}
              onClick={() => {
                if (disabled) return false;
                onClick();
              }}
            >
              {label || ""}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ButtonActions;
